import React from 'react';
import styled from 'styled-components';
import loadable from '@loadable/component';
import { palette } from 'theme';
import Container from 'components/Container';

const BasicMenu = loadable(() => import('views/Layout/Header/elements/Menus'), {
  resolveComponent: components => components.BasicMenu
});
const LargeMenu = loadable(() => import('views/Layout/Header/elements/Menus'), {
  resolveComponent: components => components.LargeMenu
});
const ProductMenu = loadable(
  () => import('views/Layout/Header/elements/Menus'),
  {
    resolveComponent: components => components.ProductMenu
  }
);
const ActionStrip = loadable(
  () => import('views/Layout/Header/elements/Menus'),
  {
    resolveComponent: components => components.ActionStrip
  }
);
const FeaturedCard = loadable(() =>
  import('views/Layout/Header/elements/FeaturedCard')
);

const MegaItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 280px;
`;

const MegaContainer = styled(Container)`
  display: flex;
  width: calc(100% + 48px);
`;

const MegaRow = styled.div`
  display: flex;
  width: calc(100% + 48px);
  margin: 0 -24px;
`;

const MegaColumn = styled.div`
  flex-basis: 33.33%;
  margin-top: 24px;
`;

const MegaStrip = styled.div`
  background-color: ${palette.grey[50]};
  padding: 14px 0;
  width: 100%;
  margin-top: auto;
`;

const ItemWrapper = styled.div`
  margin-bottom: 24px;
  padding: 0 24px;
`;

const MegaItem = ({ sections }) => (
  <MegaItemWrapper>
    <Container>
      <MegaRow>
        {(sections || []).map(
          (section, idx) =>
            section.column &&
            section.column.items && (
              <MegaColumn key={idx}>
                {section.column.items.map((item, idx) => (
                  <ItemWrapper key={idx}>
                    {item.basic_menu && (
                      <BasicMenu
                        heading={item.basic_menu.heading}
                        items={item.basic_menu.items}
                      />
                    )}
                    {item.large_menu && (
                      <LargeMenu
                        heading={item.large_menu.heading}
                        items={item.large_menu.items}
                      />
                    )}
                    {item.product_menu && (
                      <ProductMenu
                        family={item.product_menu.product_family}
                        text={item.product_menu.text}
                        groups={item.product_menu.groups}
                        actions={item.product_menu.actions}
                      />
                    )}
                    {item.featured_card && (
                      <FeaturedCard {...item.featured_card} />
                    )}
                  </ItemWrapper>
                ))}
              </MegaColumn>
            )
        )}
      </MegaRow>
    </Container>
    {(sections || []).map(
      (section, idx) =>
        sections.action_strip && (
          <MegaStrip key={idx}>
            <MegaContainer>
              <ActionStrip
                icon={section.action_strip.icon}
                label={section.action_strip.label}
                items={section.action_strip.items}
              />
            </MegaContainer>
          </MegaStrip>
        )
    )}
  </MegaItemWrapper>
);

export default MegaItem;
